import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core'
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Subscription } from 'rxjs'

import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-input',
  templateUrl: './bmcore-input.component.html',
  styleUrls: ['./bmcore-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BmcoreInputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BmcoreInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreInputComponent implements OnInit, OnDestroy {
  @Input() title: string
  @Input() type: 'email' | 'password' | 'text'
  @Input() controlFormName: string
  @Input() className: 'edit-profile'

  lg: LgType

  form: UntypedFormGroup
  subscriptions: Subscription[] = []

  constructor(
    private i18nService: I18nService,
    private formBuilder: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.form = this.formBuilder.group({
      [this.controlFormName]: [
        '',
        this.controlFormName === 'email'
          ? [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,8}$')]
          : Validators.required
      ]
    })

    this.subscriptions.push(
      // any time the inner form changes update the parent of any change
      this.form.valueChanges.subscribe(value => {
        this.onChange(value)
        this.onTouched()
      })
    )
  }

  get value() {
    return this.form.value
  }

  set value(value) {
    this.form.setValue(value)
    this.onChange(value)
    this.onTouched()
  }

  onChange: any = () => {}
  onTouched: any = () => {}

  writeValue(value) {
    if (value) {
      this.value = value
    }

    if (value === null) {
      this.form.reset()
    }
  }

  registerOnChange(fn) {
    this.onChange = fn
  }

  registerOnTouched(fn) {
    this.onTouched = fn
  }

  // communicate the inner form validation to the parent form
  validate(_: UntypedFormControl) {
    return this.form.valid ? null : { value: { valid: false } }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe())
  }
}
